import React from "react";
import { RollbackOutlined as Undelete } from '@ant-design/icons';
import { Tooltip } from '@servahealth/serva-ui-kit';

interface UndeleteIconProps {
  onClick?: () => void;
  className?: string;
  style?: React.CSSProperties;
  tooltipText?: string;
}

const UndeleteIcon: React.FC<UndeleteIconProps> = ({
  onClick,
  className,
  style,
  tooltipText,
}) => {
  return (
    <Tooltip title={tooltipText}>
      <Undelete onClick={onClick} className={className} style={style} />
    </Tooltip>
  );
};

export default UndeleteIcon;
